import { render, staticRenderFns } from "./SpintaxModal.vue?vue&type=template&id=04a12328&"
import script from "./SpintaxModal.vue?vue&type=script&lang=js&"
export * from "./SpintaxModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports